var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78375 6.49168L0.848756 0.155346C0.654303 -0.0521345 0.339479 -0.0517858 0.145352 0.156419C-0.0486252 0.364598 -0.048124 0.701831 0.146354 0.909473L5.72808 6.86868L0.146152 12.8279C-0.0483011 13.0355 -0.0488024 13.3725 0.145149 13.5807C0.242464 13.6851 0.369952 13.7373 0.497441 13.7373C0.624604 13.7373 0.751591 13.6855 0.84873 13.5818L6.78375 7.24565C6.8774 7.14589 6.92996 7.01013 6.92996 6.86868C6.92996 6.72723 6.87725 6.59163 6.78375 6.49168Z",
    fill: "#272D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevron);
export default __webpack_public_path__ + "static/media/shevron.0bfac5e9f45e2345f193b4d60d11dcd1.svg";
export { ForwardRef as ReactComponent };